"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "./lib/utils.js";
const labelVariants = cva("ui:flex ui:items-baseline ui:gap-1.5 ui:font-sans ui:text-base/7 ui:font-semibold ui:text-fg ui:peer-disabled:cursor-not-allowed ui:peer-disabled:opacity-70 ui:sm:text-sm/6");
const Label = React.forwardRef(({ className, children, hint, ...props }, ref) => {
    if (!hint) {
        return (_jsx("label", { ref: ref, className: cn(labelVariants(), className), ...props, children: children }));
    }
    return (_jsxs("label", { ref: ref, className: cn(labelVariants(), className), ...props, children: [children, _jsx("span", { className: "ui:font-mono ui:text-[0.625rem] ui:font-normal ui:text-fg-faint", children: hint === "optional" ? "Optional" : "Required" })] }));
});
Label.displayName = "Label";
export { Label };
